import { AbstractControl, ValidatorFn } from '@angular/forms';

export function MinTrimLengthValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return (control.value || '').trim().length >= minLength
      ? null
      : { 'trim length': 'trim length is shorter than required trim length' };
  };
}
